import React from "react";
import OperatorServiceTickets from "../../components/dashboard/OperatorServiceTickets";

const OperatorPlatformSale = () => (
  <OperatorServiceTickets
    serviceCode="sales"
    title="Relation client"
    lead="Les demandes liées au module de relation client de Gestion 360."
  />
);

export default OperatorPlatformSale;
